class ClickAndCollect {
	constructor(settings) {
		this.settings = settings;
		this.element = document.getElementById('cnc-container');
		this.resultsContainer = document.getElementById('cnc-results-container');
		this.mapContainer = document.getElementById('cnc-map-container');
		this.messages = {};
		this.mapFocus = null;
		if (this.settings.enableMap && window.mapIsReady) {
			this.mapReady();
		}
	}
	addMessage(name, value, isError) {
		if (!this.messages[name]) {
			var message = new Message(value, isError);
			this.messages[name] = message;
			this.resultsContainer.appendChild(message.getElement());
		}
	}
	removeMessage(name) {
		if (this.messages[name]) {
			this.messages[name].getElement().outerHTML = '';
			delete this.messages[name];
		}
	}
	clearErrors() {
		for (let [name, message] of Object.entries(this.messages)) {
			if (message.isError) {
				this.removeMessage(name);
			}
		}
	}
	addAddressSearch() {
		this.search = new AddressSearch(this);
		this.mapContainer.appendChild(this.search.getElement());
	}
	addMap() {
		this.gmap = new GMap(this);
		this.mapContainer.appendChild(this.gmap.getElement());
		this.gmap.initMap();
	}
	mapReady() {
		this.addAddressSearch();
		this.addMap();
	}
	searchAddress(address) {
		var geocoder = new google.maps.Geocoder();
		var parent = this;
		geocoder.geocode({address: address}, function(results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				parent.removeMessage('addressNotFound');
				parent.mapFocus = results[0].geometry.location;
				parent.results.setLocation(parent.mapFocus.lat(), parent.mapFocus.lng());
				parent.results.update();
				parent.gmap.show();
			} else {
				parent.results.setLocation(null, null);
				parent.addMessage('addressNotFound', address + ' not found.', true);
			}
		});
	}
	updateMap() {
		this.gmap.searchLocationsNear(this.mapFocus, this.results.getAllOutlets());
	}
}

class ClickAndCollectProduct extends ClickAndCollect {
	constructor(settings, initialVariantId) {
		super(settings);
		this.initialVariantId = initialVariantId;
		this.addCheckStockButton();
		this.addResults();
		if (this.mapContainer) {
			this.mapContainer.style.display = 'none';
		}
	}
	addCheckStockButton() {
		var checkStockButton = new CheckStockButton(this);
		this.element.appendChild(checkStockButton.getElement());
	}
	addResults() {
		var results = new ProductResults(this, this.settings.apiPrefix, this.settings.subdomain, this.initialVariantId);
		this.results = results;
		this.resultsContainer.appendChild(this.results.getElement());
	}
	addVariantEventListener() {
		var form = document.querySelector('form[action="/cart/add"]');
		if (form) {
			form.addEventListener('click', (event) => {
				if (this.results.isLoaded()) {
					this.results.unload();
					this.clearErrors();
					if (this.settings.enableMap) {
						this.mapContainer.style.display = 'none';
						this.gmap.hide();
					}
				}
			});
		}
	}
	reveal() {
		if (this.settings.enableMap) {
			this.mapContainer.style.display = '';
		} else {
			this.results.fetch();
		}
	}
	resultsLoaded() {
		if (this.settings.enableMap && this.results.count() < 1) {
			this.addMessage('pleaseSearchAgain', 'Sorry, no pickup locations are available in this area.', true);
		} else {
			this.removeMessage('pleaseSearchAgain');
		}
	}
}

class Renderable {
	getElement() {
		return this.element;
	}
	show() {
		this.element.style.display = '';
		if (this.label) {
			this.label.style.display = '';
		}
	}
	hide() {
		this.element.style.display = 'none';
		if (this.label) {
			this.label.style.display = 'none';
		}
	}
}

class AddressSearch extends Renderable {
	constructor(cnc) {
		super();
		this.cnc = cnc;
		this.createElement();
	}
	createElement() {
		this.element = document.createElement('div');
		this.element.classList.add('cnc-address-search');
		this.element.id = 'cnc-address-search';
		this.label = document.createElement('p');
		this.label.innerHTML = 'Search for a location to pick up your order:';
		this.element.appendChild(this.label);
		this.input = document.createElement('input');
		this.input.type = 'text';
		this.input.classList.add('cnc-address-search-input');
		this.input.placeholder = 'Enter your postcode...';
		this.element.appendChild(this.input);
		this.button = document.createElement('button');
		this.button.type = 'button';
		this.button.classList.add('cnc-address-search-button');
		this.button.innerHTML = '<i class="fas fa-search"></i><span class="cnc-address-search-label">Search</span>';
		this.element.appendChild(this.button);
		this.button.addEventListener('click', (event) => {
			this.cnc.searchAddress(this.input.value);
		});
		var parent = this;
		this.input.addEventListener('keyup', function(event) {
			if (event.keyCode === 13) {
				event.preventDefault();
				parent.button.click();
				return false;
			}
		});
		this.input.addEventListener('keydown', function(event) {
			if (event.keyCode === 13) {
				event.preventDefault();
				return false;
			}
		});
	}
}

class GMap extends Renderable {
	constructor(cnc) {
		super();
		this.cnc = cnc;
		this.gmap;
		this.markers = [];
		this.infoWindow;
		this.locationSelect;
		this.mapInitialised = false;
		this.createElement();
	}
	createElement() {
		this.element = document.createElement('div');
		this.element.id = 'cnc-map';
		this.hide();
	}
	initMap() {
		var sydney = {lat: -33.863276, lng: 151.107977};
		this.gmap = new google.maps.Map(this.element, {
			center: sydney,
			zoom: 11,
			zoomControl: true,
			mapTypeId: 'roadmap'
		});
		this.infoWindow = new google.maps.InfoWindow();
		this.mapInitialised = true;
	}
	clearLocations() {
		this.infoWindow.close();
		for (var i = 0; i < this.markers.length; i++) {
			this.markers[i].setMap(null);
		}
		this.markers.length = 0;
	}
	searchLocationsNear(center, outlets) {
		this.clearLocations();
		var bounds = new google.maps.LatLngBounds();
		for (let [name, outlet] of Object.entries(outlets)) {
			var bounds = new google.maps.LatLngBounds();
			var address = outlet.getAddressHtml();
			var distance = 0;
			var latlng = new google.maps.LatLng(
				parseFloat(outlet.getContact().latitude),
				parseFloat(outlet.getContact().longitude)
			);
			this.createMarker(latlng, name, address, outlet.data.distance);
			bounds.extend(latlng);
		}
		if (outlets.length >= 1) {
			this.gmap.fitBounds(bounds);
			var zoom = this.gmap.getZoom();
			this.gmap.setZoom(zoom > 10 ? 10 : zoom);
		} else {
			this.gmap.setCenter(center);
		}
	}
	createMarker(latlng, name, address, distance) {
		var html = `<b>${name}</b><br>`;
		if (distance) {
			html += distance + 'km<br>';
		}
		html += address;
		var marker = new google.maps.Marker({
			map: this.gmap,
			position: latlng
		});
		var parent = this;
		google.maps.event.addListener(marker, 'click', function() {
			parent.infoWindow.setContent(html);
			parent.infoWindow.open(parent.gmap, marker);
		});
		this.markers.push(marker);
	}
}

class ModeButton extends Renderable {
	constructor(cnc, value) {
		super();
		this.cnc = cnc;
		this.value = value;
		this.createElement();
		this.createLabel();
		this.element.addEventListener('change', (event) => {
			this.cnc.setMode(this.element.value);
		});
		this.updateDisplay();
	}
	select() {
		if (!this.element.checked) {
			this.element.checked = true;
		}
	}
	updateDisplay() {
		if (this.element.checked) {
			this.label.classList.add('btn--secondary');
		} else {
			this.label.classList.remove('btn--secondary');
		}
	}
	createElement() {
		this.element = document.createElement('input');
		this.element.id = `cnc-${this.value}-radio`;
		this.element.type = 'radio';
		this.element.name = 'attributes[cnc-fulfilment-method]';
		this.element.value = this.value;
	}
	createLabel() {
		this.label = document.createElement('label');
		this.label.setAttribute('for', `cnc-${this.value}-radio`);
		this.label.classList.add('btn');
		if (this.value === 'home') {
			this.label.innerHTML = '<i class="fas fa-globe-americas"></i><br>Home Delivery';
		} else if (this.value === 'store') {
			this.label.style.display = 'none';
			this.label.innerHTML = '<i class="fas fa-store"></i><br>Store Pickup';
		}
	}
	getLabel() {
		return this.label;
	}
	getValue() {
		return this.element.value;
	}
}

class CheckStockButton extends Renderable {
	constructor(cncProduct) {
		super();
		this.cncProduct = cncProduct;
		this.createElement();
		this.element.addEventListener('click', (event) => {
			var addToCartButton = document.querySelector('form[action="/cart/add"] button[type="submit"]');
			if (addToCartButton && addToCartButton.disabled) {
				this.cncProduct.addMessage('productUnavailable', 'Product variant is unavailable.', true);
			} else {
				this.cncProduct.removeMessage('productUnavailable');
				this.cncProduct.reveal();
			}
		});
	}
	createElement() {
		this.element = document.createElement('button');
		this.element.innerHTML = 'Check stock in store';
		this.element.classList.add('btn');
	}
}

class Outlet extends Renderable {
	constructor(cnc, data, cartItems) {
		super();
		this.cnc = cnc;
		this.data = data;
		this.createAvailabilityTable(cartItems);
		this.createLabel();
	}
	getAvailability() {
		return this.availabilityTable && this.availabilityTable.isOutletAvailable();
	}
	getAvailabilityTable() {
		return this.availabilityTable;
	}
	createAvailabilityTable(cartItems) {
		this.availabilityTable = new AvailabilityTable(
			cartItems,
			this.data.stock,
			this.data,
			true,
			this.cnc.settings.showQuantity,
		);
	}
	isSelected() {
		return this.element.checked;
	}
	select() {
		this.element.checked = true;
	}
	deselect() {
		this.element.checked = false;
	}
	getContact() {
		return this.data.contact;
	}
	getName() {
		return this.data.name;
	}
	createLabel() {
		this.label = this.getAvailabilityTable().getElement();
	}
	getAddressHtml() {
		var address = document.createElement('span');
		address.id = `cnc-outlet-${this.data.external_id}-address`;
		var innerHtml = '';
		if (this.data.contact.address1) {
			innerHtml += this.data.contact.address1 + '<br>';
		}
		if (this.data.contact.address2) {
			innerHtml += this.data.contact.address2 + '<br>';
		}
		if (this.data.contact.address3) {
			innerHtml += this.data.contact.address3 + '<br>';
		}
		if (this.data.contact.suburb) {
			innerHtml += this.data.contact.suburb + ' ';
		}
		if (this.data.contact.state) {
			innerHtml += this.data.contact.state + ' ';
		}
		if (this.data.contact.postcode) {
			innerHtml += this.data.contact.postcode;
		}
		innerHtml += '<br>';
		if (this.data.contact.phone) {
			innerHtml += `Phone: <a href="tel:${this.data.contact.phone}">${this.data.contact.phone}</a><br>`;
		}
		if (this.data.contact.email) {
			innerHtml += `Email: <a href="mailto:${this.data.contact.email}">${this.data.contact.email}</a>`;
		}
		return innerHtml;
	}
	getLabel() {
		return this.label;
	}
}

class ProductOutlet extends Outlet {
	constructor(cnc, data, cartItems) {
		super(cnc, data, cartItems);
	}
	createAvailabilityTable(cartItems) {
		this.availabilityTable = new AvailabilityTable(
			cartItems,
			this.data.stock,
			this.data,
			true,
			this.cnc.settings.showQuantity
		);
	}
	createLabel() {
		this.label = this.getAvailabilityTable().getElement();
	}
}

class AvailabilityTable extends Renderable {
	constructor(cartItems, stockLevels, outlet, showTable, showQuantity) {
		super();
		this.products = [];
		this.outlets = [];
		this.showTable = showTable;
		this.showQuantity = showQuantity;
		this.updateProducts(cartItems, stockLevels);
		this.updateOutlets(outlet);
		this.createElement();
	}
	updateOutlets(outlet) {
		this.outlets.push(outlet);
	}
	updateProducts(cartItems, stockLevels) {
		if (cartItems && cartItems.length) {
			for (let cartItem of cartItems) {
				var product = Object.assign({}, cartItem);
				product.outletStock = stockLevels[cartItem.variant_id];
				this.products.push(product);
			}
		} else {
			for (let [variantId, stockLevel] of Object.entries(stockLevels)) {
				let variantTitle = (document.querySelector(`[data-product-select] option[value="${variantId}"]`).text).split(' / ')[0]
				var product = {
					variant_id: variantId,
					variant_title: variantTitle,
					outletStock: stockLevel,
					quantity: 1
				};
				this.products.push(product);
			}
		}
	}
	isOutletAvailable() {
		for (let product of this.products) {
			if (!this.isProductAvailable(product)) {
				return false;
			}
		}
		return true;
	}
	isProductAvailable(product) {
		return product.outletStock >= product.quantity;
	}
	createElement() {
		if (this.showTable) {
			this.createTableElement();
		} else {
			this.createTextElement();
		}
	}
	createTableElement() {
		/*
			tbody
		*/
		var body = document.createElement('tr');
		var row = '';
		for (let o of this.outlets) {
			const storeName = o.name;
			var storePhone = '';
			var storePhoneLink = '';

			if(o.contact.phone) {
				storePhone = o.contact.phone;
				storePhoneLink = '+64' + storePhone;
				storePhoneLink = storePhoneLink.replace('+640', '+64').replace(' ', '').replace(' ', '');
			}

			row += `<td class="col-store-info"><span class="store-name">${storeName}</span><span class="store-phone no-br"><a href="tel:${storePhoneLink}">${storePhone}</a></span></td>`
			row += `<td class="col-phone"><span class="no-br"></span></td>`
			for (let i in o.stock) {
				if (o.stock[i] > 0) {
					row += `<td><span class="cnc-icon-tick"></span></td>`
				} else {
					row += `<td><span class="cnc-icon-cross"></span></td>`
				}
			}
			body.insertAdjacentHTML('beforeend', `<tr>${row}</tr>`);
		}
		this.element = body;
	}
	createTextElement() {
		this.element = document.createElement('p');
		this.element.classList.add('cnc-heading-availability');
		if (this.isOutletAvailable()) {
			if (this.showQuantity && this.products.length === 1) {
				this.element.innerHTML = `${this.products[0].outletStock} available`;
			} else {
				this.element.innerHTML = 'In stock';
			}
			this.element.classList.add('cnc-heading-available');
		} else {
			this.element.innerHTML = 'Out of stock';
			this.element.classList.add('cnc-heading-unavailable');
		}
	}
}

class OutletContactField extends Renderable {
	constructor(name, id, elementName) {
		super();
		this.name = name;
		this.createElement(id, elementName);
	}
	createElement(id, elementName) {
		this.element = document.createElement('input');
		this.element.type = 'hidden';
		this.element.classList.add('cnc-contact');
		this.element.id = id || `cnc-contact-${this.name}`;
		this.element.name = elementName || `attributes[cnc-store-${this.name}]`;
		this.element.value = '';
	}
	getElement() {
		return this.element;
	}
	clear() {
		this.element.value = '';
	}
	setValue(value) {
		this.element.value = value;
	}
}

class Message extends Renderable {
	constructor(value, isError) {
		super();
		this.createElement();
		this.setValue(value);
		this.setIsError(isError);
	}
	createElement() {
		this.element = document.createElement('div');
		this.element.id = 'cnc-message';
		this.paragraph = document.createElement('p');
		this.element.appendChild(this.paragraph);
	}
	getValue() {
		return this.value;
	}
	setValue(value) {
		this.value = value;
		this.paragraph.innerHTML = value;
	}
	clear() {
		this.setValue('');
	}
	setIsError(bool) {
		this.isError = bool;
		if (this.isError) {
			this.element.classList.add('cnc-negative-text');
		} else {
			this.element.classList.remove('cnc-negative-text');
		}
	}
}

class Results extends Renderable {
	constructor(cnc, apiPrefix, subdomain) {
		super();
		this.cnc = cnc;
		this.apiPrefix = apiPrefix;
		this.subdomain = subdomain;
		this.outlets = {};
		this.loaded = false;
		this.lastUpdate = 0;
	}
	update() { }
	fetch() { }
	createElement() {
		this.element = document.createElement('table');
		this.element.id = 'cnc-results';
		this.element.style.display = 'none';
	}
	createTableHead() {
		this.thead = document.createElement('thead');
		this.thead.classList.add('cnc-outlets__head');
		this.element.appendChild(this.thead);
	}
	createTableBody() {
		this.tbody = document.createElement('tbody');
		this.tbody.id = 'cnc-outlets';
		this.tbody.classList.add('cnc-outlets__body');
		this.element.appendChild(this.tbody);
	}
	setLocation(latitude, longitude) {
		this.latitude = latitude;
		this.longitude = longitude;
	}
	getAllOutlets() {
		return this.outlets;
	}
	count() {
		return Object.keys(this.outlets).length;
	}
	unload() {
		this.outlets = [];
		while (this.tbody.firstChild) {
			this.tbody.removeChild(this.tbody.firstChild);
		}
	}
	renderOutlet(outlet) {
		this.tbody.appendChild(outlet.getLabel());
	}
	isLoaded() {
		return this.loaded;
	}
	doOutletsExist() {
		return Object.keys(this.outlets).length > 0;
	}
	areOutletsAvailable() {
		for (let [key, outlet] of Object.entries(this.outlets)) {
			if (outlet.getAvailability()) {
				return true;
			}
		}
	}
}

class ProductResults extends Results {
	constructor(cnc, apiPrefix, subdomain, initialVariantId) {
		super(cnc, apiPrefix, subdomain);
		this.createElement();
		this.createTableHead();
		this.createTableBody();
		this.initialVariantId = initialVariantId;
		this.createHeadElements();
		this.fetch();
	}
	createElement() {
		this.element = document.createElement('table');
		this.element.id = 'cnc-results';
	}
	createHeadElements() {
		const arr = this.initialVariantId.split(',');
		this.tr = document.createElement('tr');
		let firstEl = document.createElement('th');
		firstEl.setAttribute('colspan', '2');
		firstEl.classList.add('col-store-info-head');
		firstEl.innerHTML = `<div class="stock-wrapper"><span class="in-stock"><span class="cnc-icon-tick"></span> In Stock</span><span class="out-of-stock"><span class="cnc-icon-cross"></span> Out of stock</span></div>`;
		this.tr.appendChild(firstEl);
		for (let a of arr) {
			let th = document.createElement('th');
			th.innerHTML = document.querySelector(`[data-product-select] option[value="${a}"]`).text.split(' / ')[0];
			this.tr.appendChild(th);
		}
		this.thead.appendChild(this.tr);
	}
	update() {
		this.fetch();
	}
	fetch() {
		this.unload();
		var parent = this;
		var variantId = this.initialVariantId;
		var url = `https://${this.apiPrefix}/api/shopify_stores/${this.subdomain}/outlets?variant_ids=${variantId}`;
		if (this.latitude && this.longitude) {
			url += `&latitude=${this.latitude}&longitude=${this.longitude}`;
		}
		fetch(url)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				for (let outletJson of json.outlets) {
					var outlet = new ProductOutlet(parent.cnc, outletJson);
					parent.outlets[outlet.getName()] = outlet;
					parent.renderOutlet(outlet);
				}
				parent.loaded = true;
				if (parent.cnc.settings.enableMap) {
					parent.cnc.updateMap();
				}
				parent.cnc.resultsLoaded();
			});
	}
	getSelectedVariantIdFromHtml() {
		var select = document.getElementById('ProductSelect-product-template');
		if (select) {
			return select.options[select.selectedIndex].value;
		}
	}
	findGetParameter(parameterName) {
		var result = null,
		tmp = [];
		location.search
			.substr(1)
			.split("&")
			.forEach(function (item) {
				tmp = item.split("=");
				if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
			});
		return result;
	}
}
